const organizationMainDataActions = {
  ORGANIZATION_MAIN_DATA_INIT: 'ORGANIZATION_MAIN_DATA_INIT',
  ORGANIZATION_MAIN_DATA_SET: 'ORGANIZATION_MAIN_DATA_SET',
  ORGANIZATION_MAIN_DATA_PROP_SET: 'ORGANIZATION_MAIN_DATA_PROP_SET',
};
export default organizationMainDataActions;
